export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-foreground-950">
      <div className="max-w-6xl mx-auto text-center">
        <p className="text-xs font-medium text-foreground-400 uppercase tracking-wider mb-6">
          About CSSBuy Sheet
        </p>
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight max-w-3xl mx-auto">
          What is CSSBuy Spreadsheet
          <br />
          How It Works
          <br />
          Safety First
        </h2>

        <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-7 py-3 bg-background-50 text-foreground-950 text-sm font-medium rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
          >
            Browse Spreadsheets
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-7 py-3 bg-transparent text-background-50 text-sm font-medium rounded-full border border-background-50/30 hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
          >
            Learn More
          </a>
        </div>

        <div className="mt-16 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
          {[
            { icon: 'ri-refresh-line', label: 'Updated Daily' },
            { icon: 'ri-shield-check-line', label: 'Verified Sources' },
            { icon: 'ri-user-smile-line', label: 'Beginner Friendly' },
            { icon: 'ri-money-dollar-circle-line', label: '100% Free' },
            { icon: 'ri-guide-line', label: 'Agent Guides' },
          ].map((item) => (
            <div
              key={item.label}
              className="bg-foreground-800/60 rounded-xl p-4 text-center"
            >
              <i className={`${item.icon} text-background-50 text-xl mb-2 block`}></i>
              <span className="text-xs text-background-50/80 font-medium whitespace-nowrap">
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}